import Widget from 'components/widget';
import { ScreenContext } from 'components/screen';
import { Screen } from 'components/screen';

export class IsVisible extends Widget {
  public static selector = '*[data-is-visible]';
  protected condition: (context: ScreenContext) => boolean;

  constructor(screen: Screen, el: HTMLLinkElement) {
    super(screen, el);
    const conditionString = (el.getAttribute('data-is-visible') as string).trim();
    this.condition = eval(`(function(context) { return ${conditionString}; });`);
    this.updateVisibility();
  }

  updateVisibility() {
    const isVisible = this.condition(this.screen.context);
    if (isVisible) {
      this.el.style.display = 'block';
    } else {
      this.el.style.display = 'none';
    }
  }
}

export default IsVisible;
